export const DATA_REFRESH_ALERTS = {
  dashboard_alert: 1,
  invoices_alert: 30,
  add_invoice_alert: 50,
  pop_up_alert: 75,
  block_invoice_alert: 90
}

export const alerts = {
  timeRange1to15: {
    // 1 to 15 days
    earlyStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: true,
      pop_up_alert: true
    }
  },
  timeRange1to30: {
    // 15 to 30 days
    earlyStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: true,
      pop_up_alert: false
    },
    midStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: true,
      pop_up_alert: true
    }
  },
  timeRange1to16: {
    // 1 to 60 days
    earlyStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: false,
      pop_up_alert: false
    },
    midStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: false,
      pop_up_alert: false
    },
    laterStage: {
      dashboard_alert: true,
      invoices_alert: true,
      add_invoice_alert: true,
      pop_up_alert: true
    }
  }
}

export const APP_TYPES = {
  RFP: 'RFP', // Portal RF
  PSCF: 'PSCF', // Portal SCF
  NDAJ: 'NDAJ' // New onboarding journey
}

export const unauthenticatedAPIList = [
  'business/applications/call/plaid_item_update_link_token',
  'business/applications/call/submit_plaid_public_token',
  'business/applications/call/get_plaid_token',
  'access/token'
]

export const PLAID_ERROR_CODE = [
  'ACCESS_NOT_GRANTED',
  'INSTANT_MATCH_FAILED',
  'INSUFFICIENT_CREDENTIALS',
  'INVALID_CREDENTIALS',
  'INVALID_MFA OTP',
  'INVALID_MFA',
  'INVALID_MFA',
  'INVALID_SEND_METHOD',
  'INVALID_UPDATED_USERNAME',
  'ITEM_CONCURRENTLY_DELETED',
  'ITEM_LOCKED',
  'ITEM_LOGIN_REQUIRED',
  'ITEM_NOT_FOUND',
  'ITEM_NOT_SUPPORTED',
  'MFA_NOT_SUPPORTED',
  'NO_ACCOUNTS',
  'NO_AUTH_ACCOUNTS',
  'NO_INVESTMENT_ACCOUNTS',
  'NO_INVESTMENT_AUTH_ACCOUNTS',
  'NO_LIABILITY_ACCOUNTS',
  'PRODUCT_NOT_ENABLED',
  'PRODUCT_NOT_READY',
  'PRODUCTS_NOT_SUPPORTED',
  'USER_INPUT_TIMEOUT',
  'USER_SETUP_REQUIRED',
  'INSTITUTION_DOWN',
  'INSTITUTION_NO_LONGER_SUPPORTED',
  'INSTITUTION_NOT_AVAILABLE',
  'INSTITUTION_NOT_ENABLED_IN_ENVIRONMENT',
  'INSTITUTION_NOT_FOUND',
  'INSTITUTION_NOT_RESPONDING',
  'INSTITUTION_REGISTRATION_REQUIRED',
  'UNAUTHORIZED_INSTITUTION',
  'INTERNAL_SERVER_ERROR',
  'PLANNED_MAINTENANCE'
]

export const DOC_TAG = {
  ci_doc: 'invoice',
  bl_docs: 'bl',
  additional_docs: 'additional',
  pod_docs: 'past_proof_of_delivery',
  pci_docs: 'past_commercial_invoice',
  pop_docs: 'past_proof_of_payment',
  bank_statement: 'bank-statement',
  financials: 'financials',
  itr: 'itr'
}

export const FLAGS = {
  Afghanistan: 'AF',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua And Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bonaire Sint Eustatius And Saba': 'BQ',
  'Bosnia And Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'British Overseas Territory Of Virgin Islands': 'AX',
  Brunei: 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Cape Verde': 'CV',
  'Caribbean Netherlands': 'NL',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  Croatia: 'HR',
  Cuba: 'CU',
  Curacao: 'CW',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territory': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guinea: 'GN',
  'Guinea Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard And Mcdonald Islands': 'HM',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  Iran: 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  Israel: 'IL',
  Italy: 'IT',
  'Ivory Coast': 'CI',
  Jamaica: 'JM',
  Japan: 'JP',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  Laos: 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  Libya: 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'North Korea': 'KP',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  'Republic Of The Congo': 'CD',
  Reunion: 'RE',
  Romania: 'RO',
  Russia: 'RU',
  Rwanda: 'RW',
  'Saint Kitts And Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Maarten': 'SX',
  'Saint Pierre And Miquelon': 'PM',
  'Saint Vincent And The Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome And Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia And South Sandwich Islands': 'GS',
  'South Korea': 'KR',
  'South Sudan': 'SS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  'St Helena': 'SH',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard And Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  Syria: 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  'Timor Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad And Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks And Caicos': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States Of America': 'US',
  'United States Of America Minor Outlying Islands': 'UM',
  'United States Of America Virgin Islands': 'VG',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  'Vatican City': 'VA',
  Venezuela: 'VE',
  Vietnam: 'VN',
  'Wallis And Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW'
}

export const CURRENCY_MAP = {
  USD: 'usd',
  EUR: 'euro',
  GBP: 'pound',
  MXN: 'mxn',
  AUD: 'aud',
  SGD: 'sgd',
  NZD: 'nzd',
  AED: 'aed',
  YEN: 'yen',
  CAD: 'cad',
  CHF: 'chf'
}

export const CURRENCY_MAP_LABEL = {
  usd: 'USD($)',
  euro: 'EUR(€)',
  pound: 'GBP(£)',
  mxn: 'Pesos(MXN$)',
  aud: 'AUD(A$)',
  sgd: 'SGD(S$)',
  nzd: 'NZD(NZ$)',
  aed: 'AED(د.إ)',
  yen: 'YEN(¥)',
  cad: 'CAD(C$)',
  chf: 'CHF(₣)'
}
export const ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update'
}

export const ENTITIES = {
  INVOICE: 'invoice',
  BANK: 'bank'
}
